<template>
    <div class="tile is-ancestor"
         droppable="true">
      <div class="tile is-parent">
        <article class="tile is-child box">

          <div class="field is-horizontal">
            <div class="field-label">
              <h3>Confirm your password to access this page</h3>
              <br/>
              <label class="label">Password</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <input class="input password" type="password" placeholder="Enter your password" v-model="currentPass">
                </div>
              </div>
            </div>
          </div>
          <div v-show="error"
               style="color:red; word-wrap:break-word;">{{ error }}</div>
          <div class="field is-horizontal">
              <a class="button is-primary" @click="confirmPass()">
                Confirm
              </a>
          </div>
        </article>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AuthenticationService from '../../services/authenticationservice'
import moment from 'moment'
export default {
  data() {
    return {
      user: {},
      error: '',
      currentPass: ''
    }
  },
  methods: {
    ...mapActions([
      'expandMenu',
      'toggleDevice',
      'toggleSidebar'
    ]),
  confirmPass(){
      var data = {} 
      var self=this
      data.password = this.currentPass
      var url = this.getQueryParamByName("to");
      AuthenticationService.confirmPassword(self, data,function(){
        window.localStorage.setItem('checkInAt', moment().format())
      },'/payslip/'+ url)
  },
  getQueryParamByName(name){
    return this.$route.query[name];
  }
  }

}
</script>

<style lang="scss">
@import '~animate.css';

.animated {
  animation-duration: .377s;
}

@import '~bulma';
@import "~vue-wysiwyg/dist/vueWysiwyg.css";

$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome';

html {
  background-color: whitesmoke;
}


.is-horizontal {
  padding: 5px 0px;
}

.password {
  width: 30%;
  min-width: 200px;
}
</style>



// WEBPACK FOOTER //
// ConfirmPassword.vue?102c7ae8